import { render } from "./MovieItem.vue?vue&type=template&id=474096d0"
import script from "./MovieItem.vue?vue&type=script&lang=js"
export * from "./MovieItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__